import React from "react";
import logoViz from "../../assets/images/logo-viziona-white.png";

import "./MenuPage.css";
import { Link } from "react-router-dom";
export default function MenuPage() {
  return (
    <div className="menupage_container">
      <div>header</div>
      <div className="container d-flex flex-column align-items-center justify-content-center g-5 buttons-container">
        <img src={logoViz} />
        <div className="services_menu">
          {/* {!cinemas_balance ? ( */}
          <>
            <button onClick={() => console.log("click")}>
              <div className="services_item">
                {/* <img src={cinemas} alt="Cinemas" /> */}
                Ver mi estado
              </div>
            </button>
            <button onClick={() => console.log("click")}>
              <div className="services_item">
                {/* <img src={register} alt="Cinemas" /> */}
                Registrarme
              </div>
            </button>
          </>
          {/* ) : null} */}
          <Link to="/peliculas">
            <div className="services_item">
              {/* <img src={boleta} alt="Boleta" /> */}
              Comprar Boletas
            </div>
          </Link>
          <Link to="/confectionery">
            <div className="services_item">
              {/* <img src={confiteria} alt="Confiteria" /> */}
              Comprar Confitería
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
